/* eslint-disable */
import React from 'react';
import WizardContinueButton from '~/layouts/WizardContinueButton';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '~/hooks/useScreenSizes';
import { Button, Typography } from 'antd';
import styled from 'styled-components';
import { useGetApplication, useSelectApplicationStage, useSelectStep } from '~/controllers/wizard';
import { getStagePayload } from '~/utils/getStagePayload';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import WizardTopNavigation from '~/layouts/uae/WizardTopNavigation';

function Actions(props: any) {
  const { t } = useTranslation('common');
  const { form, disabled, ...rest }: any = props;

  const applicationQuery: any = useGetApplication();
  const stagePayload = getStagePayload.wizard(applicationQuery.data);
  const selectStepMutation = useSelectStep();
  const payloadData = applicationQuery?.data?.payload;
  const dispatch = useDispatch();
  const location = useLocation();
  const { state }: any = location;
  const isItLetsStarted = location.pathname === '/wizard/review/letsGetStarted';
  const selectStepHandler = async (stagePayload: any, payloadData: any, arrowType: string) => {
    const stageOrder = stagePayload?.steps?.flatMap((obj: any) =>
      obj.steps?.length ? obj.steps : obj
    );
    const { uiKey: activeUiKey } = stagePayload?.activeStep;
    const findIndex = stageOrder?.findIndex((item: any) => item?.uiKey === activeUiKey);

    if (!stageOrder[findIndex + 1] && arrowType === 'NEXT') return;
    if (!stageOrder[findIndex - 1] && arrowType === 'BACK') return;
    const { key, uiKey } =
      arrowType === 'BACK' ? stageOrder[findIndex - 1] : stageOrder[findIndex + 1];

    if (state?.from) {
      await selectStepMutation.mutateAsync(state?.from);
    } else {
      await selectStepMutation.mutateAsync(key);
    }
  };

  const isMobile = useIsMobile();

  // Show "Continue" for Business Owner page, "Submit" for others
  const isBusinessOwnerPage = location.pathname.includes('/businessOwners');
  const buttonText = isBusinessOwnerPage ? t('Continue') : t('Submit');

  return isMobile ? (
    <WizardContinueButton {...rest} id="WizardContinueButton" disabled={disabled}>
      {buttonText}
    </WizardContinueButton>
  ) : (
    <BtmActions>
      <WizardTopNavigation />
      <WizardContinueButton {...rest} id="WizardContinueButton" disabled={disabled}>
        {buttonText}
      </WizardContinueButton>
    </BtmActions>
  );
}
const BtmActions = styled.div<any>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 50%;
  margin-left: auto;
  gap: 16px;
  direction: ltr;
  .backBtn {
    border-radius: 8px;
    border: 1px solid #0069b1;
    background: #f5f9fc;
    color: #0069b1;
  }
`;

export default Actions;
